import { badgeComponentProps } from '../../utils/component';
import { RadioProps } from '../radio/radio.types';
import { BadgeReturnType } from './badge.types';

export const badgeProps = (
  props: Pick<RadioProps, 'color'> & { isPill?: boolean }
): BadgeReturnType => {
  const { color = 'primary', isPill = false } = props;

  const defaultProps = badgeComponentProps[color];
  const containerProps = `${badgeComponentProps[`${color}Container`]} ${
    isPill ? 'rounded-full' : ''
  }`;

  return {
    badge: defaultProps as string,
    container: containerProps as string
  };
};
